import { useQuery } from '@tanstack/vue-query';
import { useExperienceApi } from '@/shared/api/useExperienceApi.ts';
import { type MaybeRefOrGetter, unref } from 'vue';
import { useLoaderStore } from '@/shared/store/useLoaderStore';

export const useCountryInfo = (countrySlug: MaybeRefOrGetter<string>, enabled: MaybeRefOrGetter<boolean>) => {
  const loaderStore = useLoaderStore();

  const { getCountryInfoBySlug } = useExperienceApi();

  const { data: countryInfo } = useQuery({
    queryKey: ['cityInfo', countrySlug],
    queryFn: async () => {
      const result = await getCountryInfoBySlug({ path: { countrySlug: unref(countrySlug) as string } });

      loaderStore.check404(result);

      return result;
    },
    enabled: computed(() => !!unref(enabled)),
    select: (response) => response.data,
    retry: false,
  });

  return {
    countryInfo,
  };
};
